module.exports = __webpack_public_path__ + "static/img/fiend.6252ae6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/monster/fiend.png
// module id = zq95
// module chunks = 0